export default class ErrorId {
  /**   
   * @param errorId{number}
   * @param errorDetails{string}
   * @param errorKey{string}
   * @param backendError{string}
   */
  constructor(errorId, errorDetails, errorKey, backendError) {
    /**
     * @type {number}
     */
    this.errorId = errorId;
    /**
     *
     * @type {string}
     */
    this.errorDetails = errorDetails;
    /**
     *
     * @type {string}
     */
    this.errorKey = errorKey;
    /**
     *
     * @type {string}
     */
    this.backendError = backendError;
  }

  toString() {
    return this.errorDetails;
  }

  static PREVIEW_INFO_LOAD_FAIL = "Fail to load the preview info. ";
}